import _ from 'lodash';
import React__default from 'react';
import { CheckboxGroup as CheckboxGroup$1, Label } from 'react-aria-components';
import { Checkbox } from './Checkbox.js';
import './CheckboxGroup.scss';

const CheckboxGroup = (props) => {
    return (React__default.createElement(CheckboxGroup$1, { ..._.omit(props, 'items', 'label'), "data-rev-component": 'checkbox-group', className: props.className },
        props.label ? (React__default.createElement(Label, { className: 'checkbox-group-label--rev' }, props.label)) : null,
        props.items?.map((option) => (React__default.createElement(Checkbox, { key: option.value, value: option.value, label: option.label ?? _.startCase(option.value.toLowerCase()), isDisabled: option.isDisabled, ...option.itemProps })))));
};

export { CheckboxGroup };
//# sourceMappingURL=CheckboxGroup.js.map
